<template>
  <Card class="h-full" :pt="{
					body: {
						style: { 'overflow-y': 'hidden' }
					},
					content: {
						style: {
							'overflow-y': 'scroll',
							'border-top': 'solid 1px rgb(203,213,225)',
							'margin-top': '0.75rem',
							'margin-bottom': '-1rem',
						}
					}
				}">
    <template #title>{{ $t('widgets.lists.device_config_updates_list.config_change_requests') }}</template>
    <template #content>
      <List class="flex-1 -mx-4 px-4 sm:-mx-6 sm:px-6 h-full -mt-6">
        <DevicesConfigUpdatesListItem
            v-for="configChangeRequest in configChangeRequests"
            :key="configChangeRequest.id"
            :config-change-request="configChangeRequest"
            :show-initiated-at="showInitiatedAt"
            :show-initiated-by="showInitiatedBy"
            class="hover:bg-slate-50 -mx-6 px-6"
        />
      </List>

      <p v-if="!loading && !configChangeRequests.length" class="text-sm text-surface-500 py-4">
        {{ $t('widgets.lists.device_config_updates_list.no_config_change_requests') }}
      </p>
    </template>
  </Card>
</template>

<script>
import List from "@/Components/List.vue";
import {mapStores} from "pinia";
import {useConfigChangeRequestsStore} from "@/stores/configChangeRequests.js";
import DevicesConfigUpdatesListItem from "@/Widgets/Lists/DevicesConfigUpdatesListItem.vue";

export default {
  name: "DevicesConfigUpdatesList",
  components: {
    DevicesConfigUpdatesListItem,
    List
  },
  data() {
    return {
      configChangeRequests: [],
      loading: false,
      params: {
        // No status filter, so requests of every status are returned.
        sort: 'created_at',
        order: 'desc',
        per_page: 100,
      },
    }
  },
  props: {
    device: {
      type: [Number, String],
    },
    showInitiatedAt: {
      type: Boolean,
      default: true,
    },
    showInitiatedBy: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapStores(useConfigChangeRequestsStore),
  },
  methods: {
    async refreshConfigChangeRequests() {
      this.loading = true;
      try {
        const response = await this.configChangeRequestsStore
            .indexDeviceConfigChangeRequests(this.device, this.params);
        this.configChangeRequests = response?.data ?? [];
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    'device': {
      async handler(newValue) {
        if (newValue && newValue !== 'NEW') {
          await this.refreshConfigChangeRequests();
        } else {
          this.configChangeRequests = [];
        }
      },
      immediate: true,
    }
  },
}
</script>

<style scoped>

</style>
